import { Outlet } from 'react-router-dom';

import { ReloadPrompt } from '@/app/reloadPrompt';

const Root = () => {
  return (
    <>
      <Outlet />
      <ReloadPrompt />
    </>
  );
};

export default Root;
